// Enable Prettier formatting and IDE syntax highlighting
// This file can be aliased to "graphql-tag" if necessary
export default function gql(chunks, ...variables) {
    return chunks.reduce((accumulator, chunk, index) => `${accumulator}${chunk}${index in variables ? variables[index] : ""}`, "");
}
